/*global require*/
if(window.PAGE_STATIC_CACHE && window.localStorage && localStorage.getItem("jwt-token")){
    //get static cache but is logged, don't use cache
    delete window.PAGE_STATIC_CACHE;
}

if(window.APP_NAME && window.location.pathname && !window.location.hash){
    window.location.hash = "#"+window.location.pathname.replace("/"+window.APP_NAME, "") ;
}

if(! window.isCordova){

    var offlineRuntime = require('offline-plugin/runtime');
    offlineRuntime.install({
        onUpdating: function() {
        console.log('SW Event:', 'onUpdating');
        },
        onUpdateReady: function() {
        console.log('SW Event:', 'onUpdateReady');
        // Tells to new SW to take control immediately
        offlineRuntime.applyUpdate();
        },
        onUpdated: function() {
        console.log('SW Event:', 'onUpdated');
        // Reload the webpage to load into the new version
        window.location.reload();
        },
    
        onUpdateFailed: function() {
        console.log('SW Event:', 'onUpdateFailed');
        },
        onInstalled:function() {
        console.log('SW Event:', 'onInstalled');
        }
    });
    
    if(navigator.serviceWorker){
        navigator.serviceWorker.onmessage = event => {
            if(typeof(event.data) === "string"){
                const message = JSON.parse(event.data);
                notifyDistantDataChange(message.refreshId, message.data) ;
            }
        } ;
    }
}

const realFetch = fetch ;
window.realFetch = realFetch ;
window.fetch = function(url, options){
    try{
        const jwt = localStorage.getItem("jwt-token") ;
        if(jwt){
            if(!options){
                options = {} ;
            }
            if(!options.headers){
                options.headers = {} ;
            }
            if(!options.headers.Authorization && !options.headers.authorization){
                options.headers.Authorization = "Bearer "+jwt ;
            }
        }
        const lang = localStorage.getItem("lang") ;
        if(lang){
            if(!options){
                options = {} ;
            }
            if(!options.headers){
                options.headers = {} ;
            }
            if(!options.headers["x-lang"]){
                options.headers["x-lang"] = lang ;
            }
            if(!options.headers["x-timezone"]){
                options.headers["x-timezone"] = Intl.DateTimeFormat().resolvedOptions().timeZone ;
            }
        }
    }catch(err){
        console.warn("Can't access to local storage", err) ;
    }
    return realFetch(url, options) ;
} ;

window.fetchDownload = function(url){
    let responseFilename, contentType ;
    return fetch(url).then((response)=>{
        if(response.status < 200 || response.status > 299){
            return response.text().then((text)=>{
                let msg = text;
                try{
                    msg = JSON.parse(text) ;
                }catch(e){
                    //ignore parse error, it is not a JSON object
                }
                if(!msg){
                    msg = "error" ; 
                }
                throw msg ;
            }) ;
        }
        let disposition = response.headers.get("content-disposition") ;
        contentType = response.headers.get("content-type") ;
        if(disposition){
            const indexStart = disposition.indexOf('="') ;
            if(indexStart !== -1){
                const indexEnd = disposition.indexOf('"', indexStart+2) ;
                if(indexEnd !== -1){
                    responseFilename = disposition.substring(indexStart+2, indexEnd) ;
                }
            }
        }
        return response.arrayBuffer(); 
    }).then(buffer => {
        var file = new Blob([buffer], {type: contentType});
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        const url = window.URL.createObjectURL(file);
        a.href = url;
        a.download = responseFilename;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a) ;
    }) ;
} ;

function getRestApi(app){
    if(app){ 
        app += "/" ; 
    }else{
        app = "" ;
    }
    return {
        read: function(table, id){
            return fetch("/api/"+app+"rest/"+table+"/"+encodeURIComponent(id), {
                method: "GET", 
                credentials: 'include', 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        },
        _getSearchUrl: function(table, search){
            let {select, join, where, orderby, limit, offset, groupby, fetch2many, deepLevel} = search||{} ;
            let url = "/api/"+app+"rest/"+table ;
            if(select){
                url += "/select" ;
                if(!Array.isArray(select)){
                    select = [select] ;
                }
                for(let s of select){
                    url += "/"+encodeURIComponent(s) ;
                }
            }
            if(join){
                if(!Array.isArray(join)){
                    join = [join] ;
                }
                for(let j of join){
                    url += "/join" ;
                    if(j.one){ url += "one" ; }
                    if(!j.table){ throw "Missing table on join" ; }
                    url += "/"+j.table ;
                    if(j.from){
                        url += "/from/"+j.from ;
                    }
                    if(j.on){
                        url += "/on" ;
                        if(!Array.isArray(j.on)){
                            j.on = [j.on] ;
                        }
                        for(let on of j.on){
                            url += "/"+on ;
                        }
                    }
                    if(j.as){
                        url += "/as/"+j.as ;
                    }
                }
            }
            if(where){
                if(!Array.isArray(where)){
                    where = [where] ;
                }
                if(where.length>0){
                    url += "/where" ;
                    for(let w of where){
                        url += "/"+encodeURIComponent(w) ;
                    }
                }
            }
            if(groupby){
                if(!Array.isArray(groupby)){
                    groupby = [groupby] ;
                }
                if(groupby.length>0){
                    url += "/groupby/"+groupby.join("/");
                }
            }
            if(orderby){
                if(!Array.isArray(orderby)){
                    orderby = [orderby] ;
                }
                if(orderby.length>0){
                    url += "/orderby" ;
                    for(let o of orderby){
                        url += "/"+o ;
                    }
                }
            }
            if(limit){
                url += "/limit/"+limit;
            }
            if(offset){
                url += "/offset/"+offset;
            }

            let getParams = [] ;
            if(fetch2many){
                getParams.push("fetch2many=true") ;
            }
            if(deepLevel){
                getParams.push("deepLevel="+deepLevel) ;
            }
            if(getParams.length>0){
                url += "?"+getParams.join("&") ;
            }
            return url;
        },
        search: function(table, search){
            let url = this._getSearchUrl(table, search) ;
            return fetch(url, {
                method: "GET", 
                credentials: 'include', 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        },
        list: function(table, filters){
            let getFilter = "" ;
            if(filters){
                getFilter = "?"+
                    filters.map((filter)=>{
                        return filter.column+"="+encodeURIComponent(filter.value) ;
                    }).join("&")
                ;
            }
            return fetch("/api/"+app+"rest/"+table+getFilter, {
                method: "GET", 
                credentials: 'include', 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        },
        create: function(table, obj){
            const {body, headers} = prepareFormData(obj);
            return fetch("/api/"+app+"rest/"+table, {
                method: "POST", 
                credentials: 'include', 
                body: body,
                headers: headers
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        },
        createMany: function(table, records){
            var form = document.createElement("form");
            form.setAttribute("method", "POST");
            form.setAttribute("enctype", "multipart/form-data");
            const formData  = new FormData(form);

            formData.append('records', JSON.stringify(records)) ;

            return fetch("/api/"+app+"rest/"+table, {
                method: "POST", 
                credentials: 'include', 
                body: formData
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        },
        update: function(table, id, obj){
            if(table && Array.isArray(table)){
                obj = table;
                id = "__multiple" ;
                table = "__write" ;
            }
            const {body, headers} = prepareFormData(obj);
            return fetch("/api/"+app+"rest/"+table+"/"+encodeURIComponent(id), {
                method: "PATCH", 
                credentials: 'include', 
                body: body,
                headers: headers
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        },
        delete: function(table, id){
            return fetch("/api/"+app+"rest/"+table+"/"+encodeURIComponent(id), {
                method: "DELETE", 
                credentials: 'include', 
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            }).then(function(response) {
                if(response.status < 200 || response.status > 299){
                    return response.text().then((text)=>{
                        let msg = text;
                        try{
                            msg = JSON.parse(text) ;
                        }catch(e){
                            //ignore parse error, it is not a JSON object
                        }
                        if(!msg){
                            msg = "error" ; 
                        }
                        throw msg ;
                    }) ;
                }
                return response.json() ;
            });
        }
    };
}

window.getRestApi = getRestApi;
window.restApi = getRestApi("");

import { Router } from "./libs/router.js" ;
import { ViewController } from "./libs/view-controller.js";
import pathToRegexp from 'path-to-regexp';
import { refresh, logout } from "./api/auth";
import { configure, translateElement, tr, setLocale, getCurrentLang, locale, getTr } from './util/locales' ;
import { bind, notifyDistantDataChange, prepareFormData } from "./libs/binding.js";
import context from "./util/context.js";
import routes from "./util/routes.js";
import { loadCss, loadScript, runLive, uuidv4, waiter } from "./util/utils.js";
import { error, info, confirm, question, viewDialog, openDialog } from "./util/dialogs.js";
import { io } from "socket.io-client";
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";


let router ;
let hasStartWizard = false;
function initModules(appName, modulesList){
    context.app = window.APP ;
    window.APP_CONTEXT = context ;

    let isAnonymous = window.APP.isAnonymous ;
    

    let currentController = null;
    function openView(viewController, screen, subScreen, mustLogin){
        return function(route){
            if(window.PAGE_STATIC_CACHE === route.pathname){
                console.log("STATIC CACHE, SKIP RENDER") ;
                delete window.PAGE_STATIC_CACHE ;
                return Promise.resolve() ;
            }
            delete window.PAGE_STATIC_CACHE ;
            if(mustLogin){
                if(window.APP.inner_users){
                    return innerUserLogin() ;
                }else{
                    return new ViewController(
                        { page: "/$bamz/public/resources/modules/apps/views/forbidden", id: "__forbidden" }).execRoute(route) ;
                }
            }
            if(currentController){
                if(currentController.body){
                    currentController.body.dispatchEvent(new CustomEvent("viewClosed", {bubbles: true}));
                }
            }
            context.currentScreen = screen ;
            context.currentSubScreen = subScreen ;
            currentController = viewController ;
            if(screen.label){
                document.title = screen.label +" - "+ window.APP.description ;
            }else{
                document.title = window.APP.description ;
            }
            viewController.screen = screen;
            
            return viewController.execRoute(route) ;
        } ;
    }

    let menu = [] ;
     
    const anonymousRoutes = [] ;
    let defaultRoute = null;
    let defaultRouteAnonymous = null;
    
    
    function addRoute(route, controllerGenerator, screen, code, mustLogin){
        if(route === "/start_wizard"){
            hasStartWizard = true ;
        }
        let controllerInstance = controllerGenerator();
        router.on(route, openView(controllerInstance, screen, code, mustLogin)) ;  
        const keys = [] ;
        const regexp = pathToRegexp(route, keys);
        routes.push({ regexp : regexp, keys: keys, viewControllerGenerator: controllerGenerator, screen: screen, controllerInstance: controllerInstance});
    }
    
    for(let modDef of modulesList){
        const mod = modDef.def() ;
        mod.id = modDef.name ;
        if(isAnonymous){
            if(!mod.anonymousAccess && !mod.screens.some(s=>s.anonymousAccess)){
                //no anonymous access for this module
                continue;
            }
        }
        const moduleMenu = mod.menu ;
        if(moduleMenu){
            moduleMenu.modulePk = mod.pk ;
            moduleMenu.id = mod.id ;
        }

        let labelTrKey = "menus.label."+mod.id ;
        let label = tr(labelTrKey) ;
        if(label !== labelTrKey && moduleMenu){
            moduleMenu.label = label ;
        }


        for(let screen of mod.screens){

            let labelTrKey = "screens.label."+screen.id ;
            let label = tr(labelTrKey) ;
            if(label !== labelTrKey){
                screen.label = label ;
            }

            const mustLogin = isAnonymous && !mod.anonymousAccess && !screen.anonymousAccess ;

            if(!window.APP.isAdmin && screen.profiles
                    && !screen.profiles.includes(window.APP.profile)){
                continue; //no access to this screen
            }

            const htmlPath = "/"+appName+"/public/resources/modules/"+mod.id+"/views/" ;
            screen.module = { id: mod.id } ;

            if(screen.type === "crud"){
                let baseRoute = screen.route||"/"+mod.id+"/"+screen.id ;

                let gridRoute = screen.grid?screen.grid.route:"" ;
                if(!gridRoute){
                    gridRoute = baseRoute+"/list/" ;
                }
                
    
                addRoute(gridRoute, ()=>{ return new ViewController({ page: htmlPath+screen.id+"-list", id: (screen._id||screen.id)+"-list" }) ;},
                     screen, "list", mustLogin) ;
                
                screen.route = gridRoute ;
    
                let formRoute = screen.form?screen.form.route:"" ;
                if(!formRoute){
                    formRoute = baseRoute+"/form/:mode/:id?" ;
                }

                addRoute(formRoute, ()=>{ return new ViewController({ page: htmlPath+screen.id+"-form", id: (screen._id||screen.id)+"-form" }) ; }, 
                    screen, "form", mustLogin) ;
    
    
                if(mod.anonymousAccess || screen.anonymousAccess){
                    anonymousRoutes.push(pathToRegexp(gridRoute, [])) ;
                    anonymousRoutes.push(pathToRegexp(formRoute, [])) ;
                }
                if(screen.defaultScreen){
                    defaultRoute = gridRoute ;
                }
                if(screen.defaultScreenAnonymous){
                    defaultRouteAnonymous = gridRoute ;
                }
            } else if(screen.type === "grid"){
                let gridRoute = screen.route||"" ;
                if(!gridRoute){
                    gridRoute = "/"+mod.id+"/"+screen.id+"/list" ;
                }
                
    
                addRoute(gridRoute, ()=>{ return new ViewController({ page: htmlPath+screen.id+"-list", id: screen._id||screen.id }) ;}
                    , screen, "list", mustLogin) ;
                
                if(mod.anonymousAccess || screen.anonymousAccess){
                    anonymousRoutes.push(pathToRegexp(gridRoute, [])) ;
                }
                if(screen.defaultScreen){
                    if(mod.anonymousAccess){
                        anonymousRoutes.push(/^\/$/) ;
                    }
                }
            } else if(screen.type === "form"){
                let formRoute = screen.route||"" ;
                if(!formRoute){
                    formRoute = "/"+mod.id+"/"+screen.id+"/form/:mode/:id?" ;
                }
                addRoute(formRoute, ()=>{ return new ViewController({ page: htmlPath+screen.id+"-form", id: screen._id||screen.id }) ;}, 
                    screen, "form", mustLogin) ;
    
                if(mod.anonymousAccess || screen.anonymousAccess){
                    anonymousRoutes.push(pathToRegexp(formRoute, [])) ;
                }
                if(screen.defaultScreen){
                    if(mod.anonymousAccess){
                        anonymousRoutes.push(/^\/$/) ;
                    }
                }
            } else if(screen.type === "view"){
                let route = screen.route ;
                if(!route){
                    route = "/"+mod.id+"/"+screen.id ;
                }
                
                addRoute(route, ()=>{ return new ViewController({ page: htmlPath+screen.id, id: screen._id||screen.id }) ;}
                    , screen, null, mustLogin) ;

                if(mod.anonymousAccess || screen.anonymousAccess){
                    anonymousRoutes.push(pathToRegexp(route, [])) ;
                }
                if(screen.defaultScreen){
                    if(mod.anonymousAccess){
                        anonymousRoutes.push(/^\/$/) ;
                    }
                }

                screen.route = route ;
    
                
                if(screen.defaultScreen){
                    defaultRoute = route ;
                }
                if(screen.defaultScreenAnonymous){
                    defaultRouteAnonymous = route ;
                }

                if(route === "/" && !defaultRoute){
                    defaultRoute = route ;
                }
            }
            if(moduleMenu){
                if(!moduleMenu.entries){
                    moduleMenu.entries = [] ;
                }
                const menuEntry = {
                    _id: screen._id,
                    show: screen.menu  && !mustLogin,
                    route: screen.route.replace(/:mode/, "create").replace(/:[a-zA-Z0-9_-]+\?/, ""),
                    label: screen.label
                };
                moduleMenu.entries.push(menuEntry) ;
            }
        }
        if(moduleMenu && moduleMenu.entries && moduleMenu.entries.some(e=>e.show)){
            menu.push(moduleMenu) ;
        }
    }

    if(!defaultRoute){
        defaultRoute = "/__404" ;
    }

    menu = menu.sort((m1, m2)=>{
        return (m1._index || 0) - (m2._index || 0) ;
    }) ;
    window.APP.menu = menu ;

    if(defaultRoute){
        defaultRoute = defaultRoute.split("/").filter(p=>p[0]!==":").join("/") ;
    }
    if(defaultRouteAnonymous){
        defaultRouteAnonymous = defaultRouteAnonymous.replace(/:mode/, "create").split("/").filter(p=>p[0]!==":").join("/") ;
    }

    if(isAnonymous && defaultRouteAnonymous){
        defaultRoute = defaultRouteAnonymous ;
    }

    const elWrapper = document.getElementById("wrapper");

    let baseRoute = "/" ;
    if(appName !== "$bamz"){
        baseRoute = "/"+appName+"/" ;
    }

    window.APP.baseRoute = baseRoute ;

    bind(elWrapper, {menu, context, baseRoute}) ;
    context.addRefreshListener(()=>{
        bind(elWrapper, {menu, context, baseRoute}) ;
    }) ;

    // const creatorBarController = new ViewController({ page: "/$bamz/public/resources/modules/apps/views/creator-bar" }) ;
    // creatorBarController.prepareView().then(()=>{
    //     creatorBarController.renderView(document.getElementById("top-container")) ;
    // }) ;
    // const langBarController = new ViewController({ page: "/$bamz/public/resources/modules/apps/views/lang-bar", id: "_lang_bar" }) ;
    // langBarController.data = {context} ;
    // langBarController.prepareView().then(()=>{
    //     context.addRefreshListener(()=>{
    //         langBarController.refreshView({context}) ;
    //     }) ;
    //     langBarController.renderView(document.getElementById("lang-bar")) ;
    // }) ;
    
    const elSidebar = document.getElementById("sidebar") ;
    if(elSidebar && !window.PAGE_STATIC_CACHE){
        const sideBarController = new ViewController({ page: "/$bamz/public/resources/modules/apps/views/side-bar", id: "_side_bar" }) ;
        sideBarController.data = {menu, context, baseRoute} ;  
        //console.log("first sidebar load", menu, context, baseRoute );
        sideBarController.prepareView().then(()=>{
            context.addRefreshListener(()=>{
                sideBarController.refreshView({menu, context, baseRoute}) ;
                //console.log("reload sidebar", menu, context, baseRoute );
            }) ;
            sideBarController.renderView(elSidebar) ;
            if(!sideBarController.data.context ||!sideBarController.data.context.app){
                sideBarController.refreshView({menu, context, baseRoute}) ;
            }
        }) ;
    }


    router.on("/__404", (route)=>{ 
        return new ViewController(
            { page: "/$bamz/public/resources/modules/apps/views/404", id: "__404" }).execRoute(route) ;
    }) ;
    
    router.on("/", ()=>{  return Promise.resolve(true) ; }) ;
    
    router.onNoRoute(function(){
        location.hash = "#"+defaultRoute ;
    }) ;
    
    router.onBefore(function(route){
        const remainingPopovers = document.querySelectorAll(".popover.show") ;
        for(let pop of remainingPopovers){
            if(pop.parentElement){
                pop.parentElement.removeChild(pop) ;
            }
        }

        let beforePromises = [] ;
        if(route.pathname.indexOf("/creator") === 0){
            const indexSlash = route.pathname.indexOf("/", 1);
            if(indexSlash!==-1){
                const indexNextSlash = route.pathname.indexOf("/", indexSlash+1);
                if(indexNextSlash!==-1){
                    const appName = route.pathname.substring(indexSlash+1, indexNextSlash) ;
                    beforePromises.push(window.fetch("/public/app.js?app="+appName).then((response)=>{
                            return response.text() ;
                        }).then((appJs)=>{
                            const headScript = document.createElement("script") ;
                            headScript.innerHTML = appJs ;
                            document.head.appendChild(headScript) ;
                        })
                    );
                }
            }
        }
        if(context.currentUser){ 
            beforePromises.push(Promise.resolve()) ; 
        }else if(!window.APP.isAdmin && !window.APP.isMember && !window.APP.isOwner){
            context.currentUser = {
                login: "anonymous",
                name: "Anonymous"
            } ;
            beforePromises.push(Promise.resolve()) ; 
            /*beforePromises.push(new Promise((resolve, reject)=>{
                context.currentUser = {
                    login: "anonymous",
                    name: "Anonymous"
                } ;
                if(defaultRouteAnonymous){
                    const anoRout = anonymousRoutes.find(r=>r.pathname === defaultRouteAnonymous) ;
                    if(anoRout){
                        return anoRout.exec(route.pathname) ;
                    }
                }
                let isAnonymous = anonymousRoutes.some((anoRout)=>{
                    return anoRout.exec(route.pathname) ;
                }) ;
                if(isAnonymous){
                    return resolve() ;
                }
                return reject("Route not allowed and no default route") ;
            }));*/
        }else{
            beforePromises.push(new Promise((resolve, reject)=>{
                refresh((err, user)=>{
                    if(err){
                        context.currentUser = null;
                        if(route.pathname.indexOf("/auth/login") === 0){
                            return resolve() ;
                        }
                        if(defaultRouteAnonymous){
                            const anoRout = anonymousRoutes.find(r=>r.pathname === defaultRouteAnonymous) ;
                            if(anoRout){
                                return anoRout.exec(route.pathname) ;
                            }
                        }
                        let isAnonymous = anonymousRoutes.some((anoRout)=>{
                            return anoRout.exec(route.pathname) ;
                        }) ;
                        if(isAnonymous){
                            return resolve() ;
                        }
                        return reject(err) ;
                    }
                    context.currentUser = user;
                    if(user.login !== "anonymous"){
                        if(user.lang && user.lang !== context.currentLang){
                            if(window.APP && window.APP.langs){
                                let appLang = window.APP.langs.find(l=>l.lang === user.lang) ;
                                if(!appLang){
                                    appLang = window.APP.langs.find(l=>l.lang.startsWith(user.lang)) ;
                                }
                                if(!appLang){
                                    appLang = window.APP.langs.find(l=>l.is_default) ;
                                }
                                if(appLang){
                                    user.lang = appLang.lang; 
                                }
                            }
                            context.currentLang = user.lang ;
                        }
                    }
                    
                    resolve() ;
                }) ;
            }));
        }
        return Promise.all(beforePromises) ;
    }) ;
    
    
    router.on("/logout", ()=>{  
        return logout().then(()=>{
            if(defaultRouteAnonymous){
                defaultRoute = defaultRouteAnonymous ;
            }
            isAnonymous = true ;
            router.navigateTo(defaultRoute) ;
            setTimeout(()=>{
                window.location.reload() ;
            }, 100) ;
        }) ;
    }) ;
    
    function afterRouteRender(route){
        if(route.viewContainer){
            document.getElementById("views").appendChild(route.viewContainer) ;
        }else if(route.render){
            route.render(document.getElementById("views")) ;
        }
    } 
    router.onAfter(function(route) {
        afterRouteRender(route) ;
        if(defaultRoute && route.pathname === "/" && defaultRoute !== "/"){
            router.navigateTo(defaultRoute) ;
        }
    }) ;
    
    router.onError((err, route) => {
        if(err === "NOT_LOGGED"){
            if(router.getCurrentLocation().pathname.indexOf("/auth/login") !== 0){
                router.navigateTo("/auth/login/"+encodeURIComponent(window.location.href)) ;
            }
        } else {
            console.log(err);
            error(err) ;
        }
    }) ;

    if(window.cacheViewPreload){
        for(let r of routes){
            r.controllerInstance.createViewEl(true) ;
        }
    }
}


let allComponentsRegister = [] ;
const requireComponents = require.context("./libs/components", true, /^\.\/.*\.js$/) ;
requireComponents.keys().forEach(function(c){
    const registerComponent = requireComponents(c);
    allComponentsRegister.push(registerComponent.default()) ;
});

function innerUserLogin(callback){
    if(!callback){
        callback = ()=>{} ;
    }
    return viewDialog(`
        <script>
        document.onEnter = ()=>{
            document.getElementById("saveButton").click() ;
        }

        document.forgot = ()=>{
            dialogs.viewDialog(\`
            <z-form z-save-url="/auth/forgot" z-bind-url="$emptyRecord">
                <z-field z-model='{"type": "string"}' class="d-none" z-bind="inner_app" z-default-value="${window.APP.name}"></z-field>
                <h5 data-i18n="main.pleaseEnterLoginAndEmailToRecover"></h5>
                <div class="row">
                    <div class="col-12">
                        <z-field  z-model='{"type": "string"}' z-bind="login" data-i18n="[z-label]models.users.login" required>
                        </z-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <z-field z-model='{"type": "email"}' z-bind="email" data-i18n="[z-label]models.users.email"  required>
                        </z-field>
                    </div>
                    <div class="col-12">
                        <z-error-feedback></z-error-feedback> 
                    </div>
                    <div class="col-12 pb-3">
                        <z-button-save z-next-url="onAfterSaveSignup" id="saveButton" class="w-100 btn btn-lg btn-warning">
                            <span data-i18n="main.sendPassRecoverEmail"></span>
                        </z-button-save>
                    </div>
                </div>
                
                <script>
                    document.onAfterSaveSignup = function(){
                        dialogs.info(tr("main.pleaseCheckEmail")) ;
                    };
                </script>
            </z-form>
            \`, { size: "medium"}) ;
        } ;
        </script>
        <h5 data-i18n="global.pleaseLogin" class="p-3"></h5>
        <z-form z-save-url="/auth/login" z-bind-url="$emptyRecord">
            <z-field z-model='{"type": "string"}' class="d-none" z-bind="inner_app" z-default-value="${window.APP.name}"></z-field>

            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <z-error-feedback></z-error-feedback>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="login" data-i18n="models.users.login"></label>
                            <input type="text" z-on-enter="document.onEnter()" class="form-control" autofocus id="login" z-bind="username" required />
                        </div>
                        <div class="form-group">
                            <label for="password" data-i18n="models.users.password"></label>
                            <input type="password" z-on-enter="document.onEnter()" class="form-control" id="password" z-bind="password" required />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 pb-2">
                        <z-button-save z-next-url="onAfterSave" id="saveButton" class="btn btn-lg btn-warning">
                            <span data-i18n="main.login"></span>
                        </z-button-save>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 pb-3">
                        <button class="btn btn-link" z-on-click="document.forgot()" data-i18n="main.forgotPass"></button>
                    </div>
                </div>
            </div>
        </z-form>
        <script>
            const form = document.querySelector("z-form") ;
            form.validations = [] ;
            
            form.onAfterSave = function(savedRecord){
                return new Promise((resolve, reject)=>{
                    getRootData()._globals.context.currentUser = savedRecord.user ;
                    localStorage.setItem("jwt-token", savedRecord.token) ;
                    if(window.location.hash.includes("#/logout")){
                        window.location.hash = "#/"
                    }
                    setTimeout(()=>{
                        window.location.reload();
                        resolve() ;
                    }, 10) ;
                }) ;
            };
        </script>
    `, {id : "inner_login", closeable: false, closeWithEsc: false}, callback) ;
}

let isTemplate = document.body.hasAttribute("data-run-template");
if(!isTemplate){
    let customHeaders = null;
    try{
        const jwt = localStorage.getItem("jwt-token") ;
        if(jwt){
            customHeaders = { Authorization : "Bearer "+jwt } ;
        }
    }catch(err){
        console.warn("Can't access to local storage", err) ;
    }

    waiter(
        configure({ backend: { 
            customHeaders: customHeaders,
            loadPath: window.isCordova?'app/locales/{{lng}}.json':'/public/locales/{{lng}}'
        }}).then(()=>{
            return Promise.all(allComponentsRegister) ;
        }).then(()=>{
            return window.fetch("/public/app.js").then((response)=>{
                return response.text() ;
            }).then((appJs)=>{
                const headScript = document.createElement("script") ;
                headScript.innerHTML = appJs ;
                document.head.appendChild(headScript) ;
            }) ;
        }).then(()=>{
            let currentLang = getCurrentLang() ;
            let i18nextLang = currentLang ;
            if(window.APP && window.APP.langs){
                let appLang = window.APP.langs.find(l=>l.lang === currentLang) ;
                if(!appLang){
                    appLang = window.APP.langs.find(l=>l.lang.startsWith(currentLang)) ;
                }
                if(!appLang){
                    appLang = window.APP.langs.find(l=>l.is_default) ;
                }
                if(appLang){
                    currentLang = appLang.lang; 
                    i18nextLang = currentLang ;
                    localStorage.setItem("lang", i18nextLang) ;
                }
            }
            context.currentLang = currentLang;
   
            context.sidebarOpen = true;
            const savedSidebarState = localStorage.getItem("sidebar_status") ;
            if(savedSidebarState === "closed"){
                context.sidebarOpen = false;
            }
    
            context.addRefreshListener(()=>{
                if(context.currentLang){
                    if(context.currentLang !== i18nextLang){
                        const firstDigitAreSame = (context.currentLang||"").substring(0,2) === (i18nextLang||"").substring(0,2) ;
                        i18nextLang = context.currentLang ;
                        currentLang = i18nextLang ;
                        waiter(setLocale(currentLang)).then(()=>{
                            if(!firstDigitAreSame){
                                window.location.reload() ;
                            }
                        }) ;
                    }
                }
                localStorage.setItem("sidebar_status", context.sidebarOpen?"open":"closed") ;
            }) ;
    
            translateElement(document.body) ;
    
            window.tr = function(str){
                if(str && typeof(str) !== "string"){
                    //it is an HTML Element
                    translateElement(str) ;
                }else{
                    return tr.apply(null, arguments) ;
                }
            } ;
            window.getTr = function(lang){
                return getTr({ 
                    lng: lang,
                    backend: { 
                        customHeaders: customHeaders,
                        loadPath: window.isCordova?'app/locales/{{lng}}.json':'/public/locales/{{lng}}',
                    }
                }) ;
            } ;
            window.locale = locale ;
            window.waiter = waiter ;
            window.uuidv4 = uuidv4 ;
            window.runLive = runLive ;
            window.ViewController = ViewController ;
            window.dialogs = { error, info, confirm, question, viewDialog, openDialog } ;
            let url = undefined;
            if(window.isCordova){
                url = window.cordovaSettings.serverUrl ;
            }
            window.socketio = io(url, {transports : ["websocket"]});


            window.initNotifications = async ()=>{

                if('Notification' in window){
                    const permission = await Notification.requestPermission() ;
                    if(permission === "denied"){
                        console.error("permission notification denied");
                        return null;
                    }
                    if(permission === "granted"){
                        console.info("permission notif OK") ;
                    }
                }else{
                    return null;
                }
    
                const firebaseConfig = {
                    apiKey: "AIzaSyCZ6-sTmvSQ6KmEWrZkEQt1E_McSaTDFwM",
                    authDomain: "bamz-290509.firebaseapp.com",
                    projectId: "bamz-290509",
                    storageBucket: "bamz-290509.appspot.com",
                    messagingSenderId: "990788800140",
                    appId: "1:990788800140:web:8b1bb145f5b05d2b47f5a9",
                    measurementId: "G-7F33ML6XX4"
                }; 
    
                function registerFirebaseSW(){
                    return Promise.resolve(navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/firebase-cloud-messaging-push-scope' }))
                        .then(function(registration) {

                            registration.update().catch(() => {
                                /* it is non blocking and we don't care if it failed */
                            });
                            const serviceWorker = registration.installing || registration.waiting || registration.active;

                            let whenRegistrationActive = Promise.resolve(registration);
                            if(!registration.active || registration.active.state !== 'activated') {
                                whenRegistrationActive = new Promise((resolve) => {
                                serviceWorker.addEventListener('statechange', function(e) {
                                    if (e.target.state === 'activated') {
                                    resolve(registration);
                                    }
                                });
                                });
                            }

                            return whenRegistrationActive;
                    }) ;
                }
                const serviceWorkerRegistration = await registerFirebaseSW();

                window.firebaseApp = initializeApp(firebaseConfig);
                window.firebaseMessaging = getMessaging(window.firebaseApp);
                window.firebaseToken = await getToken(window.firebaseMessaging, {
                    vapidKey: 'BJBLIc6Ft4zM9Gy3dar7NkInLXezh719fLG898K0AO0Ux3LCmK4zGL_ZZVWK3W2HifsL0DidyPsOtHMMp1hxm8g',
                    //serviceWorkerRegistration: (await navigator.serviceWorker.ready)
                    serviceWorkerRegistration: serviceWorkerRegistration
                } ) ;
                console.log("get Firebase TOKEN", window.firebaseToken) ;
                onMessage(window.firebaseMessaging, (payload) => {
                    console.log('Message received. ', payload);
                    window.document.dispatchEvent(new CustomEvent("notification", {detail: payload} )) ;
                    // ...
                });
                return window.firebaseToken ;
            } ;

            window.socketio.emit('room', "$bamz");
            window.loadScript = loadScript;
            window.loadCss = loadCss;

            Array.prototype.moveItemUp = function(item){
                let index = this.indexOf(item) ;
                if(index === 0){ return ; }
                this.splice(index,1);
                this.splice(index-1,0, item);
            } ;
            Array.prototype.moveItemDown = function(item){
                let index = this.indexOf(item) ;
                if(index === this.length-1){ return ; }
                let nextData = this[index+1] ;
                this[index+1] = item;
                this[index] = nextData;
            } ;

            
            
            if(!window.APP){
                const headThemeCss = document.createElement("link") ;
                headThemeCss.rel="stylesheet";
                headThemeCss.type="text/css";
                headThemeCss.href="/static/css/theme.css";
                document.head.appendChild(headThemeCss) ;
                return error("This application does not exists", () => {
                    if(location.pathname === "/"){
                        let subdomains = window.location.host.split(".") ;
                        subdomains[0] = "app";
                        window.location.href = window.location.protocol+"//"+subdomains.join(".")+"/" ;
                    }else{
                        window.location.href = window.location.protocol+"//"+window.location.host+"/" ;
                    }
                }) ;
            }

            window.socketio.emit('room', window.APP.name);

            if(window.APP.description){
                document.title = window.APP.description ;
            }

            const headThemeCss = document.createElement("link") ;
            headThemeCss.rel="stylesheet";
            headThemeCss.type="text/css";
            let themeUrl = "/public/app_theme.css?app="+window.APP.name+"&version="+window.APP.theme_version;
            if(window.isCordova){
                //in cordova mode, get from local
                themeUrl = "app_theme.css";
            }
            if(location.href.includes("?preview_theme")){
                themeUrl = "/public/app_theme_preview.css?app="+window.APP.name+"&version="+window.APP.theme_version;
            }
            headThemeCss.href=themeUrl;
            document.head.appendChild(headThemeCss) ;

            const headThemeGridCss = document.createElement("link") ;
            headThemeGridCss.rel="stylesheet";
            headThemeGridCss.type="text/css";
            let themeGridUrl = "/public/app_grid_theme.css?app="+window.APP.name+"&version="+window.APP.theme_version;
            if(window.isCordova){
                //in cordova mode, get from local
                themeGridUrl = "app_grid_theme.css";
            }
            headThemeGridCss.href=themeGridUrl ;
            document.head.appendChild(headThemeGridCss) ;

            //<link rel="stylesheet" type="text/css" href="/static/css/fields.css" />
            const headGlobalCss = document.createElement("link") ;
            headGlobalCss.rel="stylesheet";
            headGlobalCss.type="text/css";
            let globalCssUrl = "/"+window.APP.name+"/public/resources/global_css.css" ;
            if(window.isCordova){
                globalCssUrl = "global_css.css" ;
            }
            headGlobalCss.href=globalCssUrl;
            document.head.appendChild(headGlobalCss) ;
            
            

            let hasAccess = true;
 
            if(window.APP.error === "NO_ACCESS"){
                hasAccess = false;
            }
            if(window.APP.name === "$bamz" && location.hash.indexOf("#/creator/") === 0 && !window.APP.isAdmin && !window.APP.isMember && !window.APP.isOwner){
                hasAccess = false;
            }

            if(!hasAccess){
                if(window.APP.inner_users){
                    innerUserLogin() ;
                }else{
                    question(tr("global.noAccessPleaseLoginOrContactAdmin"), {closeWithEsc: false, size: "medium"}, [
                        {label : tr("global.backToLogin"), code: false, className: "btn-primary", focus: true, isDefault: true},
                    ]).then(()=>{
                        if(location.pathname === "/"){
                            let subdomains = window.location.host.split(".") ;
                            subdomains[0] = "app";
                            window.location.href = window.location.protocol+"//"+subdomains.join(".")+"/#/welcome/login" ;
                        }else{
                            window.location.href = window.location.protocol+"//"+window.location.host+"/#/welcome/login" ;
                        }
                    }) ;
                }
                return ;
            }

            waiter(
                window.fetch("/"+window.APP.name+"/public/resources/global_js.js").then((response)=>{
                    return response.text() ;
                }).then((appJs)=>{
                    const headScript = document.createElement("script") ;
                    appJs += "\n//# sourceURL=global_js.js" ;
                    headScript.innerHTML = appJs ;
                    document.head.appendChild(headScript) ;
                })
            ).finally(()=>{
                router = new Router(Router.HASH) ;
    
                window.router = router;
        
                initModules(window.APP.name, window.APP.modules) ;
        
                router.start();

                if(hasStartWizard){
                    viewDialog({route: "/start_wizard"}, {size: "fullscreen"}, ()=>{
                    }) ;
                }
            }) ;
        })
    ) ;
}else{
    localStorage.setItem("lang", document.body.getAttribute("data-lang")) ;
    configure({ backend: { 
        loadPath: window.isCordova?'app/locales/{{lng}}.json':'/public/locales/{{lng}}'
    }}).then(()=>{
        return Promise.all(allComponentsRegister) ;
    }).then(()=>{
        translateElement(document.body) ;
    });
}    
